import { collection } from 'common/store/actions';

export const NAMESPACE = 'WIDGETS/FIRMWARE';
const collectionActions = collection.factory(NAMESPACE);

export const {
  LOAD,
  LOAD_SUCCESS,
  LOAD_ERROR,
} = collectionActions.TYPES;

export const {
  load,
  loadSuccess,
  loadError,
} = collectionActions;
